import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import UserProfileFormLayout from './containers/Form';

export default function UserProfileLayout() {
  return <Router>
    <PrivateRoute path={["/path/dashboard/user_profile/add", "/path/dashboard/user_profile/:id"]} component={UserProfileFormLayout} />
  </Router>
}
